export default __webpack_public_path__ + "static/media/diba-layanan-kepegawaian.0c61210d.png";